import { HttpClient } from '@adapters/HttpClient';

export interface StatusOption {
  id: string;
  name: string;
}

export class StatusApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<StatusOption[]> {
    const raw = await this.httpClient.get<any>('/order-statuses');
    const list = Array.isArray(raw) ? raw : (raw.data ?? []);
    return list.map((status: any) => ({
      id: String(status.id),
      name: status.description || status.name,
    }));
  }
}
